import { JoiningProgress } from "@vivagym-joining/joining-progress";
import { LoadingStep } from "@vivagym-joining/vg-loading-step"
import { Notification } from "@vivagym/notification";
import { ShoppingCart } from "@vivagym-joining/shopping-cart";
import { VgLogs } from "@vivagym-joining/vg-logs";
import { VgJoiningGtm } from "@vivagym-joining/vg-joining-gtm";

document.addEventListener("DOMContentLoaded", async () => {
	const joiningUrlList = ["joining-1", "joining-2", "joining-3", "joining-4"];
	const url = location.href;
	const urlArray = url.split("/");
	const urlStep = urlArray[urlArray.length - 2];
	const stepIndex = urlStep.split("-")[1];

	if (!joiningUrlList.includes(urlStep)) return;

	const USER_TYPES = {
		NEW:       'New',
		GUEST:     'Guest',
		LEAD:      'Lead',
		ACTIVE:    'Active',
		INACTIVE:  'Inactive',
		SUSPENDED: 'Suspended',
	};

	const BACK_NAV_JOINING_COOKIE = 'vg_tablet_joining_url';
	const BACK_NAV_GYM_LANDING_COOKIE = 'vg_tablet_gym_url';
	const BACK_NAV_COOKIE_TTL = 86400; // 1 day

	const locale = VgHelpers.getActualDomain();
	const loadingStep = new LoadingStep();

	window.notificationsActive = true;
	window.loadMode = false;
	window.preSelectMode = false;

	let vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
	let vgLogs = new VgLogs();

	let progress = new JoiningProgress();
	const nonceValidator = new VgFormsNonce();

	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('tablet')) {
		await vgApiClient.setTablet().then((data) => {
			joiningController();
		});
	} else {
		joiningController();
	}

	function joiningController() {
		initNotifications();
		initModals();
		initTabletBackButton();

		if (stepIndex != null && stepIndex != undefined) {
			manageFooterLanguageSelector();
		}

		if (stepIndex == progress.constSelectGymStep) {
			step1Controller();
		}
		if (stepIndex == progress.constSelectQuote) {
			step2Controller();
		}
		if (stepIndex == progress.constUserData) {
			step3Controller();
		}
		if (stepIndex == progress.constSummary) {
			step4Controller();
		}
	}

	async function step1Controller() {
		progress = new JoiningProgress();
		await progress.load();

		const userHasProgress = await redirectIfUserHasProgress(progress);
		if (userHasProgress) {
			return;
		}

		await progress.load();

		const ssoResult = await initSSOLogin();

		if (ssoResult === 'redirected') {
			return;
		}

		if (ssoResult) {
			await progress.load();
		} else if (!progress.getSelectGymStep()) {
			await createGuestUser();
			await progress.load();
		}

		JoiningProgress.initStep(progress);
		await enableCompletedStepEditButton(stepIndex, progress);

		document.addEventListener("vgMapReady", async (event) => {
			loadingStep.remove();
		});

		document.addEventListener("selectedGym", async (event) => {
			const selectedGym = event.detail;
			const selectedGymCountry = selectedGym.country.toLowerCase();

			const isCountryCompatible = await isUserAndGymCountryCompatible(progress, selectedGymCountry);
			if (!isCountryCompatible) {
				VgHelpers.showModalCountryChange(selectedGymCountry);
				return;
			}

			// Check if the selected gym matches the gym in step 1
			let sameGym = progress.stepData.some(
				(step) => step.step === progress.constSelectGymStep && step.data.id === selectedGym.id
			);

			let isGymOpen = true;
			if (progress.getUserType() === USER_TYPES.ACTIVE) {
				isGymOpen = progress.checkIfGymIsOpen(selectedGym.openingDate);
				if (isGymOpen) {
					new VgModal({
						title: JoiningVars.get_form_field("modals").joining_user_active_bad_gym.title,
						description: JoiningVars.get_form_field("modals").joining_user_active_bad_gym.content,
						data: [],
						type: "error",
						template: "basic",
					});
					return;
				}
			}

			if (!sameGym) {
				// If the gym is different or step 1 does not exist, reset step 2
				progress.updateStepData(progress.constSelectQuote, {})
				progress.setBasket(null);
				progress.removeBasketResume();
				progress.setBasketParams(null);
				console.log("Gym changed or not found in step 1, reset step 2:", progress);
			}

			// Update step 1 with the selected gym
			let stepStatus = { step: stepIndex, name: 'step-joining-select-gym', data: selectedGym, completed: true };
			progress.createStep(stepStatus);
			progress.setCurrentStep(stepIndex);
			await progress.save();

			// Track gym selection event
			VgJoiningGtm.pushRegisterEventToDataLayer("select_item", {
				event_label: selectedGym.selectedView,
				club_id: progress.getGymId(),
				club_name: selectedGym.name,
				quantity: 1,
			}, null);

			if (progress.getUserType() === USER_TYPES.ACTIVE && isGymOpen) { // TODO: Why we don't redirect earlier?
				redirectToMembersArea();
				return;
			}

			const extendedAttributes = progress.getExtendedAttributes();

			setTimeout(() => {
				loadingStep.init();
			}, 500);

			const processedStep = await vgApiClient.processJoiningStepSelectGym(selectedGym, extendedAttributes, VgHelpers.getCountry());

			if (!processedStep.success) {
				console.error("Error processing step 1:", processedStep.error);
				await progress.load();
				await vgLogs.storeOnLogProblemWithProcessStep1(processedStep, progress);
				loadingStep.remove();
				return;
			}

			redirectToSelectQuote();
			return;
		});

		document.addEventListener("gtmGymSearchEvent", (event) => {

			const { searchQuery, selection } = event.detail;

			VgJoiningGtm.pushRegisterEventToDataLayer(
				'search',
				{},
				{
					event_category: 'buscador_gimnasios_registro',
					event_detail: 'busqueda_manual',
					event_label: searchQuery,
					club_name: selection.api === 'store' ? selection.description : 'sin_seleccionar',
				}
			);
		});
	}

	async function step2Controller() {
		await progress.load();

		const urlParams = new URLSearchParams(window.location.search);

		// NEW JOINING SWITCH: ?gym=&sub=&skip_quote=1 (day passes of gyms with the new join enabled): once the basket is created, go straight to the user data step.
		// Temporary, see vivagym-web/post-types/gym/vg_gym_new_joining.php (also pendingQuoteUpdates, cancelSkipQuote and the skipQuoteCancelled event).
		let skipQuote = urlParams.has('gym') && urlParams.has('sub') && urlParams.get('skip_quote') === '1';
		let pendingQuoteUpdates = 0;

		const cancelSkipQuote = () => {
			if (skipQuote) {
				skipQuote = false;
				loadingStep.remove();
			}
		};

		if (urlParams.has('gym')) {
			const gymId = urlParams.get('gym');
			let gymData = await vgApiClient.getGymById(gymId);

			if (!gymData || gymData.error != null || !gymData.name) {
				progress = new JoiningProgress();
				await progress.save();
				console.error("Unexpected gym data for ?gym= param:", gymData);
				redirectToSelectGym();
				return;
			}

			loadingStep.init();
			const gymCountry = gymData.address.country.toLowerCase();
			let processedStep = await vgApiClient.processJoiningStepSelectQuoteByUrlParams(gymId, gymData, gymCountry);

			if (!processedStep?.success) {
				console.error("Error processing step 2:", processedStep?.error);
				loadingStep.remove();
				await progress.load();
				await vgLogs.storeOnLogProblemWithProcessStep2(processedStep ?? {}, progress);
				return;
			}

			//Restore progress after PHP update
			await progress.load();
			if (!skipQuote) {
				loadingStep.remove();
			}
		}

		if (!urlParams.has('gym') && checkUserProgressBeforeContinue(progress)) { // TODO: check if we can use one unique function for all steps.
			return;
		}

		enableCompletedStepEditButton(stepIndex, progress);

		const pricePeriod = await progress.getGymPricePeriod();
		let shoppingCart = new ShoppingCart();
		shoppingCart.setGymPricePeriod(pricePeriod);
		JoiningProgress.initStep(progress);
		shoppingCart.renderBasketPreview(progress);
		shoppingCart.removeBasketLoading();

		let shoppingBasket;

		document.addEventListener("formSubscriptionUpdated", async (event) => {
			if (window.loadMode) {
				return;
			}

			pendingQuoteUpdates++;

			// Verify form nonce.
			const isNonceValid = await nonceValidator.isValidNonce('vg_select_quote_nonce', 'vg_select_quote');
			if (!isNonceValid) {
				pendingQuoteUpdates--;
				cancelSkipQuote();
				return;
			}

			// Verify reCAPTCHA if VgRecaptcha is available.
			if (typeof VgRecaptcha !== "undefined" && typeof VgRecaptcha.generateAndValidateRecaptcha === "function") {
				const formStep = document.getElementById("vg-select-quote__form");
				const verifyCapcha = await VgRecaptcha.generateAndValidateRecaptcha(formStep);
				if (verifyCapcha.error) {
					console.log('reCaptcha verification failed!');
					pendingQuoteUpdates--;
					cancelSkipQuote();
					return;
				}
			}

			let submitButton = document.querySelector('.vg-select-quote__submit');

			shoppingCart.addBasketLoading();
			submitButton.disabled = true;

			let gymId = progress.getGymId();

			const selection = event.detail;
			progress.updateStepData(stepIndex, selection);
			progress.setCurrentStep(stepIndex);

			shoppingCart.setGym(gymId);

			if (selection['vg-select-quote'][0].type === 'EFT') {
				shoppingCart.setEftSubscription(selection['vg-select-quote'][0].value);
			}

			if (selection['vg-select-quote'][0].type === 'CASH') {
				shoppingCart.setCashSubscription(selection['vg-select-quote'][0].value);
			}

			if (selection['vg-select-quote--addons']) {
				selection['vg-select-quote--addons'].forEach(addon => {
					shoppingCart.addAddOn(addon.value);
				});
			}

			if (selection['vg-select-quote--clipcard']) {
				selection['vg-select-quote--clipcard'].forEach(clipcard => {
					shoppingCart.addClipCard(clipcard.value);
				});
			}

			if (urlParams.has('promo')) {
				const promoCode = urlParams.get('promo');
				const country = progress.getGymCountry();
				if (promoCode) {
					const promoCodeOk = await vgApiClient.validatePromoCode(gymId, promoCode, country, true);
					if (promoCodeOk.error == null && promoCodeOk.valid == true) {
						shoppingCart.setPromotionCode(promoCode)
						console.log('saved promo code: ' + promoCode);
					} else {
						new VgModal({
							title: 'Error',
							description: 'El código promocional no es válido.',
							data: [],
							type: 'error',
							template: 'basic',
						});
					}
				}
			}

			shoppingCart.setCountry(progress.getGymCountry()?.toLowerCase());
			shoppingBasket = await shoppingCart.process();

			if (shoppingBasket && null === shoppingBasket.error) {
				progress.setBasket(shoppingBasket.shoppingBasket);
				progress.setBasketResume(shoppingBasket.resume);
			} else {
				if (shoppingBasket) {
					console.error("Error processing shopping cart:", shoppingBasket.error);
					if (shoppingCart.checkErrorBasket(shoppingBasket.error, 'ProductPurchaseAllowedQuantityExceededException')) {
						resetClipcardSelection();
						shoppingCart.showErrorModalClipcard();
					}
				} else {
					console.log('Retry shopping cart process');
					shoppingBasket = await shoppingCart.process();
					if (!shoppingBasket || shoppingCart.checkErrorBasket(shoppingBasket.error, 'addEFTSubscription')) {
						resetClipcardSelection();
						shoppingCart.showErrorModalBasket();
					}
				}
			}

			progress.setBasketParams(shoppingCart.collectParams());

			await progress.save();
			console.log('progress with basket', progress);

			let dataCart = VgJoiningGtm.getGABasketData(progress);
			let viewGAData = {
				value: dataCart.value ?? 0,
				currency: dataCart.currency,

				club_id: dataCart.club_id,
				club_name: dataCart.club_name,
				items: dataCart.items,
				promotion: dataCart.promotion
			};
			VgJoiningGtm.pushRegisterEventToDataLayer("view_cart", viewGAData, null);

			shoppingCart.renderBasketPreview(progress);

			// Update user extended attributes
			if (progress.getUserType() === USER_TYPES.INACTIVE || progress.getUserType() === USER_TYPES.SUSPENDED || progress.getUserType() === USER_TYPES.LEAD) {
				await updateExtendedAttributes(progress);
			}

			submitButton.disabled = false;

			pendingQuoteUpdates--;

			// NEW JOINING SWITCH: skip the quote step once every basket update (e.g. the preselected insurance one) has finished.
			if (skipQuote && 0 === pendingQuoteUpdates) {
				const selectedQuote = selection['vg-select-quote']?.[0];
				const basketOk = shoppingBasket && null === shoppingBasket.error;

				if (basketOk && selectedQuote?.globalId === urlParams.get('sub')) {
					skipQuote = false;
					document.dispatchEvent(new CustomEvent("formSubscriptionSubmit", { detail: selection }));
					return;
				}

				cancelSkipQuote();
			}
		});

		// NEW JOINING SWITCH: the quote step cancels the skip if the ?sub= subscription can't be preselected.
		document.addEventListener("skipQuoteCancelled", cancelSkipQuote);

		document.addEventListener("formSubscriptionSubmit", async (event) => {
			const selection = event.detail;

			// Verify reCAPTCHA if VgRecaptcha is available.
			if (typeof VgRecaptcha !== "undefined" && typeof VgRecaptcha.generateAndValidateRecaptcha === "function") {
				const formStep = document.getElementById("vg-select-quote__form");
				const verifyCapcha = await VgRecaptcha.generateAndValidateRecaptcha(formStep);
				if (verifyCapcha.error) {
					console.log('reCaptcha verification failed!');
					loadingStep.remove(); // NEW JOINING SWITCH: shown on ?skip_quote=1.
					return;
				}
			}

			await progress.load();

			if (shoppingBasket && null === shoppingBasket.error) {
				progress.basket = shoppingBasket.shoppingBasket;
			}

			progress.updateStepData(stepIndex, selection);
			progress.setStepCompleted(stepIndex);
			progress.setCurrentStep(stepIndex);
			await progress.save();

			const shoppingGABasketItems = VgJoiningGtm.getGABasketData(progress);
			VgJoiningGtm.pushRegisterEventToDataLayer("begin_checkout", shoppingGABasketItems, null);

			redirectToUserData();
		});

		initBasketGAListener(progress);
	}

	async function step3Controller() {
		await progress.load();
		if (checkUserProgressBeforeContinue(progress)) {
			return;
		}

		if (progress.getUserType() === USER_TYPES.ACTIVE && progress.checkIfGymIsOpen(null)) {
			showActiveUserMessageAndRedirect();
			return;
		}

		let currentStepData = progress.getUserDataStep();

		if (!currentStepData) {
			console.log('No user data found, creationg step 3');
			let step3 = { step: stepIndex, name: 'step-joining-user-data', completed: false, data: {} };
			progress.createStep(step3);
			progress.setCurrentStep(stepIndex);
			await progress.save();
		}

		JoiningProgress.initStep(progress);
		enableCompletedStepEditButton(stepIndex, progress);

		loadingStep.remove();

		// Hydrate survey blocks with the gym selected in step 1.
		const gymIdFromProgress = progress.getGymId();
		const gymCountryFromProgress = progress.getGymCountry();
		if (gymIdFromProgress) {
			document.querySelectorAll('.vg-survey').forEach((surveyBlock) => {
				surveyBlock.setAttribute('data-gym-id', String(gymIdFromProgress));
				surveyBlock.setAttribute('data-gym-country', String(gymCountryFromProgress).toLowerCase());
				surveyBlock.dispatchEvent(new CustomEvent('vg:survey:hydrate', { bubbles: false }));
			});
		}

		document.addEventListener("formDataSubmit", async (event) => {
			const formData = event.detail;

			// Verify reCAPTCHA if VgRecaptcha is available.
			if (typeof VgRecaptcha !== "undefined" && typeof VgRecaptcha.generateAndValidateRecaptcha === "function") {
				const formStep = document.getElementById("form-user-data");
				const verifyCapcha = await VgRecaptcha.generateAndValidateRecaptcha(formStep);
				if (verifyCapcha.error) {
					console.log('reCaptcha verification failed!');
					return;
				}
			}

			// Verify form nonce.
			const isNonceValid = await nonceValidator.isValidNonce('form-nonce', 'vivagym-forms-nonce');
			if (!isNonceValid) return;

			loadingStep.init();
			await progress.load();

			currentStepData = progress.getUserDataStep();
			if (!currentStepData) {
				console.log('No user data found, creationg step 3');
				let stepStatus = { step: stepIndex, name: 'step-joining-user-data', completed: false, data: {} };
				progress.createStep(stepStatus);
			}

			// NOTE: We can save formData directly in progress PHP.
			progress.updateStepData(stepIndex, formData);
			await progress.save();

			let userType   = progress.getUserType();
			let country    = progress.getUserCountry().toLowerCase();
			let gymCountry = progress.getGymCountry().toLowerCase();
			let gymId      = progress.getGymId();

			const processedStep = await vgApiClient.processJoiningStepUserData(gymId, progress.user, formData, progress.getExtendedAttributes(), gymCountry, country, progress.checkIfDayPassIsSelected());

			if (processedStep.error) {
				console.error("Error processing step 3:", processedStep.error);
				manageStepUserDatarProcessError(processedStep.error);
				await vgLogs.storeOnLogProblemWithProcessStep3(processedStep, progress);
				loadingStep.remove();
				return;
			}

			const userGAData        = await VgJoiningGtm.getGAUserInfo(progress);
			const eventDetailForGA  = formData['newsletter'] ? 'ok_promociones' : 'ko_promociones';
			const eventLabelForGA   = userType === USER_TYPES.GUEST || userType === USER_TYPES.LEAD ? 'nuevo_miembro' : 'ex_miembro';
			const ecommerceGAData   = VgJoiningGtm.getGABasketData(progress);

			const GAData = {
				event_detail: eventDetailForGA,
				event_label: eventLabelForGA,
				user_id: userGAData?.user_id,
				email_hashed: userGAData?.email_hashed,
				phone_hashed: userGAData?.phone_hashed,
			}

			VgJoiningGtm.pushRegisterEventToDataLayer("add_shipping_info", ecommerceGAData, GAData);

			redirectToSummary();
		});

		document.addEventListener("resetLead", async (event) => {
			const country = progress.getUserCountry();

			//When we need to reset a Lead, we need to Reset Previous Lead, not actual user
			const final_external_user = progress.getUserExternalId();
			console.log('Resetting lead');
			const old_external_id = event.detail.old_external_id;
			progress.setUserExternalId(old_external_id);
			await progress.save();

			const updatedUser = await vgApiClient.cleanUserLead(country);
			console.log('cleanLead', updatedUser);

			progress.setUserExternalId(final_external_user);
			// We need to update saved user's email on personData
			const email = document.querySelector("input[name='email']").value;
			progress.updateUserPersonDataEmail(email);
			await progress.save();
		});

		document.addEventListener("contractView", async (event) => {
			VgJoiningGtm.pushRegisterEventToDataLayer("ver_y_descargar_contrato", null, {event: 'click', event_category: 'add_shipping_info', event_detail: event.detail});
		});

		function isFormFilled(form) {
			for (let element of form.elements) {
				if (element.type !== "submit" && element.value.trim() !== "") {
					return true;
				}
			}
			return false;
		}

		window.addEventListener("beforeunload", async (event) => {
			await progress.load();
			currentStepData = progress.getUserDataStep();

			if (!currentStepData) {
				const form = document.querySelector("#form-user-data");

				if (isFormFilled(form)) {
					console.log("The form has filled data.");
					// Display a confirmation dialog
					event.preventDefault(); // Standard way to prevent the default action
					event.returnValue = ""; // Required for Chrome to display the dialog
				} else {
					console.log("The form is empty.");
				}
			}
		});
	}

	function manageStepUserDatarProcessError(error) {
		if (!error) return;

		if (error.includes("DUPLICATE_PERSON")) {
			console.error("DUPLICATE_PERSON");
			document.dispatchEvent(new CustomEvent('duplicatedPerson', { detail: error }));
			loadingStep.remove();
		} else if (error.includes("INVALID_EMAIL") || error.includes("Empty email or invalid") || error.includes("Invalid email") || error.includes("Missing password")) {
			console.error("Empty email or invalid");
			document.dispatchEvent(new CustomEvent('invalidEmail', { detail: error }));
			loadingStep.remove();
		} else if (error.includes("INVALID_FORM_DATA")) {
			console.error("INVALID_FORM_DATA");
			document.dispatchEvent(new CustomEvent('invalidFormData', { detail: error }));
			loadingStep.remove();
		} else if (error.includes("INVALID_NATIONAL_ID")) {
			console.error("INVALID_NATIONAL_ID");
			document.dispatchEvent(new CustomEvent('invalidNationalId', { detail: error }));
			loadingStep.remove();
		} else {
			window.location.reload();
			console.error("Error in AJAX request");
		}
	}

	async function step4Controller() {
		await progress.load();

		if (checkUserProgressBeforeContinue(progress)) {
			return;
		}
		if (!progress.getSummaryStep()) {
			console.log('No summary data found, creationg step 4');
			const step4 = { step: stepIndex, name: 'step-joining-summary', completed: false, data: {} };
			progress.createStep(step4);
			progress.setCurrentStep(stepIndex);
			await progress.save();
		}
		await JoiningProgress.initStep(progress);

		const isAnonymous = await vgApiClient.checkIfIsAnonymous(null);
		if (isAnonymous) {
			await vgLogs.storeOnLogProblemWithAnonymousStep4(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToSelectGym();
			return;
		}

		loadingStep.remove();

		let userHasRegisteredIban = false;

		document.addEventListener("VgPaymentRegisterIban", async (event) => {

			console.log('VgPaymentRegisterIban', event.detail);
			const data = event.detail;

			let sepaData = {
				accountHolder: data['account-holder-name'],
				iban: data['account-holder-iban'],
			};

			await progress.load();
			progress.setStepResumeIban(data['account-holder-iban']);
			progress.setStepResumeIbanHolder(data['account-holder-name']);
			await progress.save();

			const country = progress.getUserCountry();

			await vgLogs.storeOnLogSetPaymentAgreementSepa(data, progress);
			const updatedUserSepa = await vgApiClient.setPaymentAgreementSepa(sepaData, country);
			console.log(updatedUserSepa);

			// Send to GA add_payment_info iban
			await pushPaymentStatusToGTM("add_payment_info", 'iban', progress);

			if (updatedUserSepa.error !== null) {
				console.error('Error updating user Sepa:', updatedUserSepa.error);
				await vgLogs.sendDataToStoreOnLogCustomers('error','Could not register SEPA agreement', progress.getUserExternalId(), null);
				document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
				document.addEventListener("modalClosed", async function (event) {
					await manageResponseError(updatedUserSepa.error);
				});
			}

			userHasRegisteredIban = true;

			if (updatedUserSepa.error === null && data.requirePayNow === true) {
				await vgLogs.storeOnLogVgPaymentIbanRegistered(updatedUserSepa, progress);
				document.dispatchEvent(new CustomEvent('VgPaymentIbanRegistered', { detail: updatedUserSepa }));
			}

			if (updatedUserSepa.error === null && data.requirePayNow === false) {

				await progress.load();

				// Close shopping basket
				const shoppingBasketClosed = await closeShoppingBasket(progress);
				console.log('shoppingBasketClosed', shoppingBasketClosed);

				if (shoppingBasketClosed.error !== null) {
					console.error('Error closing shopping basket:', shoppingBasketClosed.error);
					await logPaymentFailure('CloseShoppingBasketAfterSepa', { reason: 'close_shopping_basket_error', basketError: shoppingBasketClosed.error }, progress);
					VgJoiningGtm.pushRegisterEventToDataLayer("system_registration", { 'event_detail': 'ko'}, null);
					document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
					document.addEventListener("modalClosed", async function (event) {
						await manageResponseError(shoppingBasketClosed.error);
					});
				}

				// Send to GA purchase iban
				await pushPaymentStatusToGTM("purchase", 'iban', progress);
				VgJoiningGtm.pushRegisterEventToDataLayer("system_registration", { 'event_detail': 'ok'}, null);

				await vgLogs.storeOnLogVgFinishRegisterIbanProcessWithoutPayNow(progress, progress.basketParams, shoppingBasketClosed);

				// Send to User actions log
				await sendUserActionsToLog(progress);

				await redirectToThankYouPageAndClearProgress();
			}
		});
		document.addEventListener("VgPaymentByCardRequested", async (event) => {
			// Send to GA add_payment_info by card
			await pushPaymentStatusToGTM("add_payment_info", 'tarjeta', progress);
		});

		document.addEventListener('VgPaymentSubmitted', () => {
			loadingStep.init();
		});

		document.addEventListener('VgPaymentNOTCompleted', async (event) => {
			loadingStep.remove();
			console.error('Payment failed:', event.detail);
			const data = event.detail;

			await logPaymentFailure('VgPaymentNOTCompleted', data, progress);

			// The gateway charged the user but the Middleware/Exerp did not confirm it:
			// do not send them back to pay again.
			if (true === data?.paymentCharged) {
				showPaymentChargedNotActivatedModal();
				return;
			}

			if (data.resultCode === 'Refused') {
				new VgModal({
					title: JoiningVars.get_form_field("modals").joining_adyen_not_pay.title,
					description: JoiningVars.get_form_field("modals").joining_adyen_not_pay.content,
					data: [],
					type: "error",
					template: "basic",
					status: 'Active'
				});
				document.addEventListener("modalClosed", async () => redirectToSummary());
			}
		});

		document.addEventListener('VgPaymentCompleted', async (event) => {
			console.log('VgPaymentCompleted', event.detail);
			const data = event.detail;
			if (data.status === 'success') {
				await progress.load();

				await vgLogs.storeOnLogVgFinishPayment(progress, data);

				if (true === data.freepayment) {
					const shoppingBasketClosed = await closeShoppingBasket(progress);
					await vgLogs.sendDataToStoreOnLogCustomers('info', 'All data sent to Exerp. Shopping Basket closed (Free Payment)', progress.getUserExternalId(), null);
				}

				if ('AddonPayments' === data.gateway && 'cardRegistration' === data.operation) {
					const shoppingBasketClosed = await closeShoppingBasket(progress);

					if (shoppingBasketClosed.error !== null) {
						console.error('Error closing shopping basket:', shoppingBasketClosed.error);
						loadingStep.remove();
						// The card is already registered on the gateway: warn instead of asking to retry.
						await logPaymentFailure('CloseShoppingBasketAfterCardRegistration', { ...data, paymentCharged: true, reason: 'close_shopping_basket_error', basketError: shoppingBasketClosed.error }, progress);
						showPaymentChargedNotActivatedModal();
						return;
					}

					await vgLogs.sendDataToStoreOnLogCustomers('info', 'All data sent to Exerp. Shopping Basket closed (AddonPayments card registration)', progress.getUserExternalId(), null);
				}

				//TODO: temporary disabled, actually the endpoint to check basket status is not working as expected.
				/*
				const isJoiningCompleted = await checkJoiningCompleted(progress);

				if (!isJoiningCompleted) {
					console.error('Joining process not completed after payment.');
					managePaymentError();
					return;
				}
				*/

				// Send to GA purchase
				const ecommerceMethod = userHasRegisteredIban ? 'iban' : 'tarjeta';
				await pushPaymentStatusToGTM("purchase", ecommerceMethod, progress);
				VgJoiningGtm.pushRegisterEventToDataLayer("system_registration", { 'event_detail': 'ok'}, null);

				// Send to User actions log
				await sendUserActionsToLog(progress);

				await redirectToThankYouPageAndClearProgress();
			} else {
				loadingStep.remove();
				console.error('Payment failed:', data);
				await logPaymentFailure('VgPaymentCompleted', data, progress);
				managePaymentError();
			}
		});

		document.addEventListener('VgPaymentSessionError', async (event) => {
			const { errorCode } = event.detail;

			document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
			document.addEventListener("modalClosed", async function (event) {
				if ('403' === errorCode || '401' === errorCode) {
					progress = new JoiningProgress();
					await progress.save();
					window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_init');
					return;
				}

				window.location.reload();
			});
		});
	}

	async function sendUserActionsToLog(progress) {
		const userActionBuyPayload = {
			'external_id'      : progress.getUserExternalId(),
			'email'            : progress.getStepUserDataEmail(),
			'operation_label'  : 'PAYMENT_COMPLETE',
			'operation_result' : progress.getBasketParams(),
			'origin'           : 'COPRPORATE',
			'gym_id'           : progress.getGymId(),
			'country'          : progress.getUserCountry(),
		};

		await vgApiClient.logUserAction(userActionBuyPayload);

		const requiredClipcardConditions = progress.getUserClipcardsRequiredConditions();

		if ( requiredClipcardConditions?.length > 0 ) {

			for ( const clipcardAcceptance of requiredClipcardConditions ) {

				console.log('clipcardAcceptance',clipcardAcceptance);

				const userActionProductConditionsPayload = {
					'external_id'      : progress.getUserExternalId(),
					'email'            : progress.getStepUserDataEmail(),
					'operation_label'  : 'PRODUCT_CONDITIONS',
					'operation_result' : { product: clipcardAcceptance.globalId, opt_in : clipcardAcceptance.opt_in },
					'origin'           : 'COPRPORATE',
					'gym_id'           : progress.getGymId(),
					'country'          : progress.getUserCountry(),
				};
				await vgApiClient.logUserAction(userActionProductConditionsPayload);
			}
		}
	}

	async function checkJoiningCompleted(progress) {
		const MAX_RETRIES    = 10;
		const RETRY_DELAY_MS = 1000;

		for (let attempts = 0; attempts < MAX_RETRIES; attempts++) {
			const basketStatus = await vgApiClient.getBasketExternalId(progress.getBasketKey());
			console.log('basketStatus', basketStatus);

			if (basketStatus && basketStatus.shoppingBasketStatus?.toLowerCase() === 'paid') {
				return true;
			}

			if (attempts < MAX_RETRIES - 1) {
				await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
			}
		}
		return false;
	}

	function showActiveUserMessageAndRedirect() {
		loadingStep.remove();

		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_user_member_active.title,
			description: JoiningVars.get_form_field("modals").joining_user_member_active.content,
			data: [],
			type: "error",
			template: "basic",
			status: 'Active'
		});

		document.addEventListener("modalClosed", function (event) {
			redirectToMembersArea();
		});
	}

	async function redirectToThankYouPageAndClearProgress() {
		const thankYouPageUrl = JoiningVars.get_setting_field('vg_link_thank_you_page', locale);
		const thankYouPageUrlWithDomain = '/' + VgHelpers.getActualDomain() + thankYouPageUrl;
		const gymId = progress.getGymId();
		const userToken = progress.getUserToken();

		sessionStorage.setItem('vg_utm_conversion', 'true');

		let data = [
			{ name: 'client_name', value: progress.getUserName() },
			{ name: 'client_email', value: progress.getUserEmail() },
		];
		if (gymId) {
			data.push({ name: 'gym', value: gymId });
		}
		if (userToken) {
			data.push({ name: 'client_token', value: userToken });
		}

		progress = new JoiningProgress();
		await progress.save();

		redirectPageWithPostData(thankYouPageUrlWithDomain, data);
	}

	async function pushPaymentStatusToGTM(eventName, ecommerceMethod, progress) {
		if (!eventName || !ecommerceMethod || !progress) {
			return;
		}

		const ecommerceGAData = VgJoiningGtm.getGABasketData(progress);
		const userGAData = await VgJoiningGtm.getGAUserInfo(progress);
		ecommerceGAData.coupon = progress.getBasketParams()?.promotionCode || '';
		ecommerceGAData.method = ecommerceMethod;

		if (eventName === 'purchase') {
			ecommerceGAData.transaction_id = progress.getBasket().shoppingBasketKey;
			let userType   = progress.getUserType();
			userGAData.event_label = userType === USER_TYPES.GUEST || userType === USER_TYPES.LEAD ? 'nuevo_miembro' : 'ex_miembro';
		}

		VgJoiningGtm.pushRegisterEventToDataLayer(eventName, ecommerceGAData, userGAData);
	}

	async function closeShoppingBasket(progress) {
		const basketParams = {
			shoppingBasketKey: progress.getBasket().shoppingBasketKey,
			amountPaidByCustomer: progress.getBasket().totalAmount,
			customPaymentMethodId: 1,
			externalPaymentTransactionReference: progress.getUserExternalId() + '-SB0',
		};
		const country = progress.getUserCountry();

		return await vgApiClient.payShoppingBasket(basketParams, country);
	}

	async function isUserAndGymCountryCompatible(progress, selectedGymCountry) {

		if (progress.getUserCountry().toLowerCase() === selectedGymCountry.toLowerCase()) return true;

		if (progress.getUserType() === USER_TYPES.NEW || progress.getUserType() === USER_TYPES.GUEST) return true;

		// If user is Inactive or Suspended, show modal to change country Gym.
		if (progress.getUserType() === USER_TYPES.INACTIVE || progress.getUserType() === USER_TYPES.SUSPENDED) {
			return false;
		}

		// If user is Lead, on progress we have token but we don't know if lead has password or not. We need to check if exsists.
		if (progress.getUserType() === USER_TYPES.LEAD) {

			let checkResult = await vgApiClient.checkIfExist(progress.getUserEmail(), selectedGymCountry);
			console.log("checkIfExist Result:", checkResult);

			if (checkResult.country.toLowerCase() === selectedGymCountry.toLowerCase()) return true;

			let userToken = checkResult.token;

			if (!userToken) { // Its a Lead with password.
				return false;
			}

			progress.setUserToken(userToken);
			await progress.save();
			return true;
		}
	}

	async function redirectIfUserHasProgress(progress) {
		if (VgHelpers.getCountry() !== progress.getUserCountry()) {
			progress = new JoiningProgress();
			await progress.save();
			return false;
		}

		if (progress.getRegisteredSteps().length === 0) {
			return false;
		}

		if (stepIndex == progress.constSelectGymStep) {
			return false;
		}

		if (!progress.getSelectGymStep()) {
			progress.setCurrentStep(progress.constSelectGymStep);
			await progress.save();
			redirectToSelectGym();
			return true;
		}

		if (progress.getSelectGymStep() && !progress.getSelectQuoteStep()) {
			progress.setCurrentStep(progress.constSelectQuote);
			await progress.save();
			redirectToSelectQuote();
			return true;
		}

		progress.setCurrentStep(progress.constUserData);
		await progress.save();
		redirectToUserData();
		return true;
	}

	async function manageResponseError(error) {
		if (error === '403') {
			await vgLogs.storeOnLogVGAnonymousForbiddenMethod(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToSelectGym();
		} else {
			window.location.reload();
		}
	}

	function managePaymentError() {
		VgJoiningGtm.pushRegisterEventToDataLayer("system_registration", { 'event_detail': 'ko'}, null);
		document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
		document.addEventListener("modalClosed", async () => redirectToUserData());
	}

	/**
	 * Logs a payment failure on the ATC panel (WP-Payment-Steps + customer log).
	 * Both are stored with 'error' level, which also mirrors them on the PHP error log (CloudWatch).
	 */
	async function logPaymentFailure(context, data, progress) {
		let detail;
		try {
			detail = JSON.parse(JSON.stringify(data ?? {}));
		} catch (error) {
			detail = { raw: String(data) };
		}

		const externalId = progress.getUserExternalId();
		const reason = detail.reason ?? detail.resultCode ?? detail.status ?? 'unknown';
		const paymentCharged = true === detail.paymentCharged;
		const orderId = detail.orderId ?? detail.merchantReference ?? '-';

		await vgLogs.sendDataToStoreOnLog("WP-Payment-Steps", {
			log: 'storeOnLogVgPaymentFailure',
			level: 'error',
			context: context,
			external_id: externalId,
			gym_id: progress.getGymId(),
			basket_key: progress.getBasket()?.shoppingBasketKey,
			reason: reason,
			payment_charged: paymentCharged,
			detail: detail,
		});

		let msg = 'Payment failed [' + context + '] (' + (detail.gateway ?? 'unknown') + '). Reason: ' + reason
			+ '. Charged by gateway: ' + (paymentCharged ? 'YES' : 'NO') + '. orderId: ' + orderId;
		if (detail.lastStatus) {
			msg += '. Last MW status: ' + JSON.stringify(detail.lastStatus);
		}
		if (detail.basketError) {
			msg += '. Basket error: ' + JSON.stringify(detail.basketError);
		}

		await vgLogs.sendDataToStoreOnLogCustomers('error', msg, externalId, null);
	}

	/**
	 * Warns the user that the payment was charged but the membership could not be activated.
	 * Progress is cleared so the user can not pay the same basket twice.
	 */
	function showPaymentChargedNotActivatedModal() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_payment_not_activated.title,
			description: JoiningVars.get_form_field("modals").joining_payment_not_activated.content,
			data: [],
			type: "warning",
			template: "basic",
			status: 'PaymentNotActivated'
		});
		document.addEventListener("modalClosed", async () => {
			progress = new JoiningProgress();
			await progress.save();
			window.location.href = '/' + VgHelpers.getActualDomain() + '/';
		}, { once: true });
	}

	function checkUserProgressBeforeContinue(progress) {
		if (progress.getRegisteredSteps().length === 0) {
			redirectToSelectGym();
			return true;
		}
		return false;
	}

	async function enableCompletedStepEditButton(stepIndex, progress) {
		const registeredSteps = progress.getRegisteredSteps();

		registeredSteps?.forEach((step) => {
			if (step.stepIndex === 0 || step.stepIndex <= stepIndex || step.stepIndex === undefined) {
				return;
			}
			appendEditButton(step.stepIndex);
		});
	}

	function appendEditButton(stepIndex) {
		const step = document.querySelector(`[data-index="${stepIndex}"]`);
		const stepParent = step?.parentElement;
		const stepHeader = stepParent?.parentElement;

		const editButtonText = JoiningVars.get_setting_field('vg_str_edit_step', locale);

		if (stepParent && stepHeader) {
			const editContainer = document.createElement('a');
			editContainer.classList.add('vg-joining-process__step-head-link');
			editContainer.href = `/${locale}/joining-${stepIndex}/`;

			const editText = document.createElement('div');
			editText.classList.add('vg-joining-process__step-head-link-edit');
			editText.innerHTML =
				`
			<div class="vg-joining-process__step-head-icon-edit">
				<span>${editButtonText}</span>
			</div>
			`;
			stepParent?.appendChild(editText);
			editContainer.appendChild(stepParent);

			stepHeader.innerHTML = '';
			stepHeader.appendChild(editContainer);
		}

	}

	async function updateExtendedAttributes(progress) {
		const extendedAttributes = progress.getExtendedAttributes();
		console.log('extendedAttributes', extendedAttributes);
		const updatedUser = await vgApiClient.updateUserMultipleExtendedAttribute(extendedAttributes, progress.getUserCountry());
		console.log('Updated extendedAttributes', updatedUser);
		return updatedUser;
	}

	function redirectPageWithPostData(redirectUrl, data) {
		const form = document.createElement('form');
		form.name = 'redirectForm';
		form.method = 'POST';
		form.action = redirectUrl;
		form.style.display = 'none';

		data?.forEach(field => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = field.name;
			input.value = field.value;
			form.appendChild(input);
		});

		document.body.appendChild(form);

		form.submit();
	}
	
	//https://vivagym.localhost/es-es/joining-1/?ssoToken=4933b0de-b611-4e9c-b503-6362af3985a0&externalId=103619205

	async function initSSOLogin() {
		const urlParams = new URLSearchParams(window.location.search);
		if (!urlParams.has('ssoToken') || !urlParams.has('externalId')) {
			return false;
		}

		const externalId = urlParams.get('externalId');
		const ssoToken = urlParams.get('ssoToken');
		const ssoUser = await vgApiClient.validateUserSSOToken(externalId, ssoToken, VgHelpers.getCountry());

		if (null !== ssoUser.error) {
			console.error('Error validating SSO token:', ssoUser.error);
			return false;
		}

		// If we get user's type as Lead, we need to manage it as Inactive
		const rawUserType = progress.filterUserType(ssoUser.personData?.personTypeAndStatus.personStatus);
		const user = {
			type: rawUserType === USER_TYPES.LEAD ? USER_TYPES.INACTIVE : rawUserType,
			country: ssoUser.personData?.person.address.country.toLowerCase(),
			data: ssoUser.personData,
			token: ssoUser.token ?? null,
		};

		if (user.type === 'Blacklist') {
			window.location.href = JoiningVars.get_modal_setting_field('blacklist', 'modal_redirect_url', VgHelpers.getActualDomain());
			return 'redirected';
		}

		const processedStep = await vgApiClient.processJoiningSsoLogin(user, user.country);

		if (!processedStep.success) {
			console.error("Error processing SSO login:", processedStep.error);
			await progress.load();
			await vgLogs.storeOnLogProblemWithSsoLogin(processedStep, progress);
			return false;
		}

		console.log('processedStep',processedStep);

		switch (processedStep.data.user.type) {
			case USER_TYPES.LEAD:
			//case USER_TYPES.NEW:
			//case USER_TYPES.GUEST:
				return true;
			case USER_TYPES.ACTIVE:
				redirectToMembersArea();
				return 'redirected';
			case USER_TYPES.INACTIVE:
			case USER_TYPES.SUSPENDED:
				redirectToSelectQuote();
				return 'redirected';
			default:
				console.error("User type not found");
				return false;
		}
	}

	async function createGuestUser() {

		const initStepByParam = await vgApiClient.createGuestUser(VgHelpers.getCountry());

		if (!initStepByParam.success) {
			console.error("Error processing step 1 by param tsp0:", initStepByParam.error);
			await progress.load();
			await vgLogs.storeOnLogProblemWithCreateGuestUser(initStepByParam, progress);
			//redirectToSelectGym();
			// TODO: reload page? Show modal?
			return;
		}

	}

	function initModals() {
		document.addEventListener("initModal", function (event) {
			const modalType = event.detail;

			switch (modalType) {
				case "error":
					showErrorModal();
					break;
				default:
					console.error("Modal type not found");
					break;
			}
		});
	}

	function initNotifications() {
		if (!window.notificationsActive) {
			return;
		}

		document.addEventListener("selectedGym", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").select + " " + event.detail.name,
					"success"
				);
			}
		});

		document.addEventListener("addSubscription", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added,
					"success"
				);
			}
		});

		document.addEventListener("removeSubscription", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted,
					"info"
				);
			}
		});

		document.addEventListener("removeAddon", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").service + " " + event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted2,
					"info"
				);
			}
		});

		document.addEventListener("addAddon", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").service + " " + event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added2,
					"success"
				);
			}
		});

		document.addEventListener("addClipcard", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added2,
					"success"
				);
			}
		});

		document.addEventListener("removeClipcard", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted2,
					"info"
				);
			}
		});
	}

	function initBasketGAListener(progress) {

		document.addEventListener("addSubscription", async (event) => {
			const eventLabel = window.preSelectMode || window.loadMode ? 'add_to_cart_default' : 'add_to_cart';
			VgJoiningGtm.pushShoppingCartToDataLayer(eventLabel, 'cuota', event.detail, progress);
		});

		document.addEventListener("addAddon", async (event) => {
			const eventLabel = window.preSelectMode || window.loadMode ? 'add_to_cart_default' : 'add_to_cart';
			VgJoiningGtm.pushShoppingCartToDataLayer(eventLabel, 'extra', event.detail, progress);
		});

		document.addEventListener("removeAddon", async (event) => {
			if (!window.loadMode) {
				VgJoiningGtm.pushShoppingCartToDataLayer('remove_from_cart', 'extra', event.detail, progress);
			}
		});

		document.addEventListener("addClipcard", async (event) => {
			const eventLabel = window.preSelectMode || window.loadMode ? 'add_to_cart_default' : 'add_to_cart';
			VgJoiningGtm.pushShoppingCartToDataLayer(eventLabel, 'extra', event.detail, progress);
		});

		document.addEventListener("removeClipcard", async (event) => {
			if (!window.loadMode) {
				VgJoiningGtm.pushShoppingCartToDataLayer('remove_from_cart', 'extra', event.detail, progress);
			}
		});
	}

	function manageFooterLanguageSelector() {

		let lang;
		const selectCountrySelected = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item-selected a");
		const selectCountryItems = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--items");
		const selectCountryItem = document.querySelectorAll(".site-footer__colophon-select-language .site-footer__select-language--item");
		const selectListItemCountry = document.querySelector(".site-footer__select-language");

		if (!selectCountrySelected) {
			return;
		}

		selectCountrySelected.addEventListener("click", (event) => {
			event.preventDefault();
			lang = selectCountrySelected.getAttribute("data-lang");
		});

		selectCountryItem.forEach(option => {
			option.addEventListener("click", (event) => {
				if (selectListItemCountry.getAttribute("data-activate-modal")) {
					event.preventDefault();
					const link = event.target.closest('a');
					lang = link.getAttribute("data-lang");

					if (lang === VgHelpers.getActualDomain()) {
						return;
					}

					const modalConfirmation = new VgModal({
						title: JoiningVars.get_form_field("modals").joining_change_country.title,
						description: JoiningVars.get_form_field("modals").joining_change_country.content,
						data: [],
						type: "warning",
						template: "countrySelector",
						status: "",
					});
				}
			});
		});

		document.addEventListener("modalClosed", () => {
			selectCountryItems.style.display = "none";
			selectCountrySelected.classList.remove("open");
		});

		document.addEventListener("modalLangSelectorBtn", async (event) => {
			event.preventDefault();
			const progress = new JoiningProgress();
			await progress.save();
			window.location.href = '/' + lang + '/' + JoiningVars.get_setting_field('wizard_slug_joining_init', lang);
		});

	}

	function redirectToSelectGym() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_gym');
	}
	function redirectToSelectQuote() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_quote');
	}
	function redirectToUserData() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_user_data');
	}
	function redirectToSummary() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_summary');
	}
	function redirectToMembersArea() {
		window.location.href = JoiningVars.get_setting_field('vg_link_members_area', VgHelpers.getActualDomain());
	}

	function resetClipcardSelection() {
		const clipcardAcceptance = document.querySelectorAll(
			".vg-select-quote__clipcard-conditions input"
		);

		clipcardAcceptance?.forEach((acceptance) => {
			acceptance.checked = false;
			acceptance.disabled = false;
			acceptance.nextElementSibling.removeAttribute('disabled');
		});

		const clipcardCheckboxes = document.querySelectorAll(
			'input[name="vg-select-quote--clipcard"]'
		);

		clipcardCheckboxes?.forEach((clipcard) => {
			if (clipcard.checked) {
				clipcard.click();
			}
			clipcard.disabled = true;
			clipcard.nextElementSibling.setAttribute('disabled', true);
			clipcard.dispatchEvent(new Event('change'));
		});
	}

	function showErrorModal() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_error.title,
			description: JoiningVars.get_form_field("modals").joining_error.content,
			data: [],
			type: "error",
			template: "basic",
		});
	}

	async function initTabletBackButton() {
		const isTablet = document.cookie.split(';').some(c => c.trim() === 'vg_tablet_mode=true');
		if (!isTablet) return;

		const btn = document.getElementById('vg-tablet-back-btn');
		if (!btn) return;

		document.cookie = `${BACK_NAV_JOINING_COOKIE}=${encodeURIComponent(window.location.href)};path=/;max-age=${BACK_NAV_COOKIE_TTL};SameSite=Strict;Secure`;

		const cookieEntry = document.cookie.split(';').find(c => c.trim().startsWith(`${BACK_NAV_GYM_LANDING_COOKIE}=`));
		let backUrl = cookieEntry ? decodeURIComponent(cookieEntry.trim().split('=').slice(1).join('=')) : null;

		if (!backUrl) {
			const gymCenterId = urlParams.get('gym');
			if (!gymCenterId) return;

			try {
				const response = await vgApiClient.getGymUrl(gymCenterId);
				if (response?.url) {
					backUrl = response.url.replace(/\/?$/, '/') + 'tablet/';
					document.cookie = `${BACK_NAV_GYM_LANDING_COOKIE}=${encodeURIComponent(backUrl)};path=/;max-age=${BACK_NAV_COOKIE_TTL};SameSite=Strict;Secure`;
				}
			} catch (e) {
				return;
			}
		}

		if (!backUrl) return;

		btn.href = backUrl;
		btn.style.display = 'flex';
	}
});
